import React, { useEffect } from "react";
import { Layout, Row, Col } from "antd";
import { useDispatch } from "react-redux";

//component
import LayoutHeader from "../00_Nav/layout/layout_header";
import TriggerInit from "./trigger/trigger_init";
//action
import "./style.css";
import ClientLists from "./01_List/client_lists";
import DialogAddClient from "./dialog/dialog_client_add";
import { setHighlight } from "store/bailiff/nav/nav.action";

const { Content } = Layout;

const ClientScreen = () => {
  // -------------------------- VAR --------------------------
  const title = "Tất cả khách hàng";

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(setHighlight(["1"]));
  }, [dispatch]);
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          {/* Client   */}
          <ClientLists />
        </Col>
      </Row>
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <LayoutHeader title={title} />
      <Content className="content">
        <Row justify={"center"} gutter={[0, 30]}>
          <Col xl={12} lg={12} md={22} xs={24}>
            {renderBody()}
          </Col>
        </Row>
        {/* Dialog */}
        <DialogAddClient />
        {/* Trigger */}
        <TriggerInit />
      </Content>
    </Layout>
  );
};

export default ClientScreen;
